import { useState } from "react";
import { Card } from "react-bootstrap";
import { SearchOutlined } from "@ant-design/icons";
import { AnimatePresence, motion } from "framer-motion";
import { Input, Row, Col, Select, Space, Modal, Popconfirm, Tag, message } from "antd";

import Button from "antd-button-color";

import { formatNumber } from "lib/utility";
import { productLists } from "data/product";
import Pagination from "components/Pagination";

import moment from "moment";

const RentalDetailsContainer = () => {
  const [showModal, setShowModal] = useState(false);
  const [showDetail, setShowDetail] = useState(false);

  return (
    <>
      <Card>
        <Card.Header className="bg-transparent">
          <Card.Title className="p-t-8 p-b-2">Detail Penyewaan</Card.Title>
        </Card.Header>

        <Card.Body>
          <Row gutter={[14, 14]}>
            <Col xxl={8} lg={8} md={8} sm={12} xs={12}>
              <Input prefix={<SearchOutlined />} placeholder="Cari produk" />
            </Col>
            <Col xxl={8} lg={8} md={8} sm={12} xs={12}>
              <Select placeholder="Kategori" className="w-100">
                <Select.Option value="Kursi">Kursi</Select.Option>
                <Select.Option value="Meja">Meja</Select.Option>
              </Select>
            </Col>
            <Col xxl={8} lg={8} md={8} sm={12} xs={12}>
              <Select placeholder="Status Penyewaan" className="w-100">
                <Select.Option value="Semua">Semua</Select.Option>
                <Select.Option value="Belum Bayar">Belum Bayar</Select.Option>
                <Select.Option value="Sudah Bayar">Sudah Bayar</Select.Option>
                <Select.Option value="Selesai">Selesai</Select.Option>
              </Select>
            </Col>
          </Row>
          <br />

          <Row gutter={[14, 14]}>
            {/* BELUM BAYAR */}
            <Col span={24} key={productLists[11].name}>
              <Card className="border-0 shadow-sm">
                <Card.Body>
                  <Card.Title className="bg-transparent fs-13">
                    <Space>
                      <div>Kursi</div>
                      <div className="fw-normal">{moment(new Date()).format("DD MMM YYYY")}</div>
                    </Space>
                    <div className="float-end">
                      <Space>
                        <span className="text-muted fw-light">Bayar sebelum</span>
                        <i className="far fa-clock text-danger" />
                        <span className="fw-bold text-danger">
                          {moment(new Date()).format("DD MMM, HH:mm")}
                        </span>
                      </Space>
                    </div>
                  </Card.Title>

                  <Row gutter={[16, 16]} className="w-100 mt-3" key={productLists[11].name}>
                    <Col xxl={3} xl={3} lg={4} md={5} sm={5} xs={5}>
                      <img
                        src={`/assets/img/products/${productLists[11].image}`}
                        className="cart-item-img"
                        alt={productLists[11].name}
                      />
                    </Col>
                    <Col xxl={21} xl={21} lg={20} md={19} sm={19} xs={19} className="pe-0">
                      <h5 className="my-0 fs-12-s fs-16 truncate-2">{productLists[11].name}</h5>
                      <div className="d-block text-muted">
                        <small>Jumlah: {Math.floor(Math.random() * 100) + 1} pcs</small>
                      </div>
                      <div className="d-block text-muted small">
                        Tgl sewa: {moment(new Date()).format("DD MMM YYYY")} -{" "}
                        {moment(new Date())
                          .add(Math.floor(Math.random() * 20) + 1, "days")
                          .format("DD MMM YYYY")}{" "}
                        ({Math.floor(Math.random() * 20) + 1} hari)
                      </div>
                      <div>
                        <Space>
                          <Button
                            ghost
                            type="dark"
                            size="small"
                            className="mt-2 fs-12"
                            onClick={() => setShowModal(true)}
                          >
                            Lihat Detail
                          </Button>
                          <small className="text-muted mt-2">+1 lainnya</small>
                        </Space>
                        <Space className="float-end">
                          <Button type="dark" size="small" className="mt-2 fs-12 ms-2">
                            Bayar Sekarang
                          </Button>
                          <Popconfirm
                            okText="Ya"
                            cancelText="Tidak"
                            placement="bottomRight"
                            title="Yakin ingin batalkan transaksi?"
                            onConfirm={() => message.success("Berhasil membatalkan transaksi")}
                          >
                            <Button type="text" size="small" className="mt-2 fs-12">
                              <i className="far fa-trash-alt" />
                            </Button>
                          </Popconfirm>
                        </Space>
                      </div>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Col>
            {/* BELUM BAYAR */}

            {[...Array(10)].map((_, i) => (
              <Col span={24} key={productLists[i].name}>
                <Card className="border-0 shadow-sm">
                  <Card.Body>
                    <Card.Title className="bg-transparent fs-13">
                      <Space>
                        <div>Kursi</div>
                        <div className="fw-normal">{moment(new Date()).format("DD MMM YYYY")}</div>
                        <Tag className="mx-0 mb-0 label-tag-done">Selesai</Tag>
                        <div className="fw-light">INV/20210921/MPL/1605560329</div>
                      </Space>
                    </Card.Title>

                    <Row gutter={[16, 16]} className="w-100 mt-3" key={productLists[i].name}>
                      <Col xxl={3} xl={3} lg={4} md={5} sm={5} xs={5}>
                        <img
                          src={`/assets/img/products/${productLists[i].image}`}
                          className="cart-item-img"
                          alt={productLists[i].name}
                        />
                      </Col>
                      <Col xxl={21} xl={21} lg={20} md={19} sm={19} xs={19} className="pe-0">
                        <h5 className="my-0 fs-12-s fs-16 truncate-2">{productLists[i].name}</h5>
                        <div className="d-block text-muted">
                          <small>Jumlah: {Math.floor(Math.random() * 100) + 1} pcs</small>
                        </div>
                        <div className="d-block text-muted small">
                          Tgl sewa: {moment(new Date()).format("DD MMM YYYY")} -{" "}
                          {moment(new Date())
                            .add(Math.floor(Math.random() * 20) + 1, "days")
                            .format("DD MMM YYYY")}{" "}
                          ({Math.floor(Math.random() * 20) + 1} hari)
                        </div>
                        <div>
                          <Space>
                            <Button
                              ghost
                              type="dark"
                              size="small"
                              className="mt-2 fs-12"
                              onClick={() => setShowModal(true)}
                            >
                              Lihat Detail
                            </Button>
                            <small className="text-muted mt-2">+1 lainnya</small>
                          </Space>
                          <Space className="float-end">
                            <Popconfirm
                              okText="Ya"
                              cancelText="Tidak"
                              placement="bottomRight"
                              title="Yakin ingin menghapus transaksi?"
                              onConfirm={() => message.info("Berhasil menghapus transaksi")}
                            >
                              <Button type="text" size="small" className="mt-2 fs-12">
                                <i className="far fa-trash-alt" />
                              </Button>
                            </Popconfirm>
                          </Space>
                        </div>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>

          <Row gutter={[14, 14]} className="mt-3">
            <Col span={24}>
              <Pagination
                total={60}
                current={1}
                pageSize={10}
                hideOnSinglePage
                className="text-center"
                goTo={() => {}}
              />
            </Col>
          </Row>
        </Card.Body>
      </Card>

      <Modal
        centered
        title={<div className="d-block text-center">Detail Penyewaan</div>}
        visible={showModal}
        bodyStyle={{ padding: 0 }}
        onOk={() => setShowModal(false)}
        onCancel={() => setShowModal(false)}
        closeIcon={<i className="far fa-times" />}
        footer={null}
      >
        <Card.Body className="p-4 fs-12">
          <div>
            <div className="rent-detail-data">
              <p className="text-muted mb-0">Nama Penyewa</p>
              <div>
                <p className="mb-0">Okky Suardhana</p>
              </div>
            </div>
            <div className="rent-detail-data">
              <p className="text-muted mb-0">No. Telpon</p>
              <div>
                <p className="mb-0">+62814328337</p>
              </div>
            </div>
            <div className="rent-detail-data">
              <p className="text-muted mb-0">Tgl. Pemesanan</p>
              <div>
                <p className="mb-0">{moment(new Date()).format("DD MMMM YYYY, HH:mm")}</p>
              </div>
            </div>
            <div className="rent-detail-data">
              <p className="text-muted mb-0">Tanggal Sewa</p>
              <div>
                <p className="mb-0">
                  {moment(new Date()).format("DD MMM YYYY")}
                  <span> s/d </span>
                  {moment(new Date()).add(20, "days").format("DD MMM YYYY")}
                </p>
              </div>
            </div>
            <div className="rent-detail-data">
              <p className="text-muted mb-0">Lama Sewa</p>
              <div>
                <p className="mb-0">7 hari</p>
              </div>
            </div>
          </div>
        </Card.Body>

        <div className="border-bottom-5px" />

        <Card.Body className="p-4">
          <p className="fw-500 fs-14 mb-3">Detail Katalog</p>

          {[...Array(3)].map((_, i) => (
            <Card key={productLists[i].name} className="mb-2">
              <Card.Body>
                <Row gutter={[16, 16]} className="w-100">
                  <Col xxl={3} xl={3} lg={4} md={5} sm={5} xs={5}>
                    <img
                      src={`/assets/img/products/${productLists[i].image}`}
                      className="cart-item-img sm"
                      alt={productLists[i].name}
                    />
                  </Col>
                  <Col xxl={21} xl={21} lg={20} md={19} sm={19} xs={19}>
                    <h5 className="my-0 fs-14 truncate-2">{productLists[i].name}</h5>
                    <div className="d-block text-muted">
                      <small>{Math.floor(Math.random() * 100) + 1} pcs</small>
                      <small> x Rp{formatNumber(productLists[i].price)}</small>
                    </div>
                    <div className="d-block text-muted">
                      <Button
                        ghost
                        type="dark"
                        size="small"
                        className="fs-12"
                        onClick={() => {
                          setShowDetail(!showDetail);
                        }}
                      >
                        {showDetail ? "Tutup" : "Lihat"} Detail
                      </Button>
                    </div>
                  </Col>
                </Row>
                <AnimatePresence>
                  {showDetail && (
                    <motion.div
                      className="fs-12"
                      transition={{ duration: ".5" }}
                      initial={{ opacity: 0, height: "0" }}
                      animate={{ opacity: 1, height: "100%" }}
                      exit={{ height: "0", opacity: 0 }}
                    >
                      <hr />
                      <p className="mb-0">
                        <b>Total Harga:</b>
                        <span> Rp{formatNumber(productLists[i].price)}</span>
                      </p>
                      <p className="mb-0">
                        <b>Catatan:</b>
                        <span> tolong kirim sebelum tanggal sewa</span>
                      </p>
                    </motion.div>
                  )}
                </AnimatePresence>
              </Card.Body>
            </Card>
          ))}
        </Card.Body>

        <div className="border-bottom-5px" />

        <Card.Body className="p-4">
          <p className="fw-500 fs-14 mb-3">Info Pengiriman</p>
          <table className="table table-borderless fs-12 mb-0">
            <tbody>
              <tr>
                <td className="px-0">Kurir</td>
                <td>:</td>
                <td>Karya Nadhi Decoration Logistic</td>
              </tr>
              <tr>
                <td className="px-0">Kabupaten</td>
                <td>:</td>
                <td>Badung</td>
              </tr>
              <tr>
                <td className="px-0">Alamat</td>
                <td>:</td>
                <td>
                  Jl. Muding Tengah, Bougenville No. 18 Kerobokan, Kuta Utara, Badung, Bali 80361
                </td>
              </tr>
            </tbody>
          </table>
        </Card.Body>

        <div className="border-bottom-5px" />

        <Card.Body className="p-4">
          <p className="fw-500 fs-14 mb-3">Rincian Pembayaran</p>
          <div className="fs-12">
            <div className="rent-detail-data">
              <p className="text-muted mb-0">Metode Pembayaran</p>
              <div>
                <p className="mb-0">BCA</p>
              </div>
            </div>

            <div className="border-bottom-dashed mb-2" />

            <div className="rent-detail-data">
              <p className="text-muted mb-0">Total Harga (3 barang)</p>
              <div>
                <p className="mb-0">Rp{formatNumber(60000)}</p>
              </div>
            </div>

            <div className="border-bottom-dashed mb-2" />

            <div className="rent-detail-data fw-bold fs-14">
              <p className="mb-0">Total Bayar</p>
              <div>
                <p className="mb-0">Rp{formatNumber(60000)}</p>
              </div>
            </div>
          </div>
        </Card.Body>
      </Modal>
    </>
  );
};

export default RentalDetailsContainer;
